import { retrieveValues } from "../storagewrapper.js"

export default function authHeader() {

  try {
    const obj = JSON.parse(retrieveValues("authUser"))

    if (obj && obj.token) {
      return { Authorization: obj.token, userId: obj.data._id }
    } else {
      return {}
    }

  } catch (err) {
    console.warn("cannot find authUser")
    return {}

  }

}
